import React from 'react';
import { Link } from 'react-router-dom';
import { useConsentTexts } from './useConsentTexts';

// Never pre-checked (A2P 10DLC / TCPA). Parent owns state and must default to false.
export const SmsConsentCheckbox = ({ kind = 'guest_sms_opt_in', checked, onChange, testId = 'sms-consent-checkbox' }) => {
  const texts = useConsentTexts();
  const t = texts?.[kind];
  return (
    <label data-testid={`${testId}-label`} className="flex items-start gap-2.5 text-xs leading-relaxed text-[#5A5A5A] cursor-pointer p-3 rounded-xl bg-[#FBF7F2] border border-[#EFE3D8]">
      <input
        data-testid={testId}
        type="checkbox"
        className="mt-0.5 accent-[#7B2C3B] w-4 h-4 flex-shrink-0"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        {t ? t.text : 'Loading consent wording…'}{' '}
        {kind === 'guest_sms_opt_in' && (
          <>See our <Link to="/sms-terms" target="_blank" className="underline text-[#7B2C3B]">SMS Terms</Link> and <Link to="/privacy" target="_blank" className="underline text-[#7B2C3B]">Privacy Policy</Link>.</>
        )}
      </span>
    </label>
  );
};

export default SmsConsentCheckbox;
